import React from "react";
import { components } from "../../../../../api/spec";

interface GuestFilterTabsProps {
  activeFilter: components["schemas"]["EventAttendeeStatus"] | null;
  onFilterChange: (
    filter: components["schemas"]["EventAttendeeStatus"],
  ) => void;
  counts: {
    not_signed_up: number;
    started: number;
    completed: number;
    not_started: number;
    pending_review: number;
  };
  className?: string;
}

const GuestFilterTabs: React.FC<GuestFilterTabsProps> = ({
  activeFilter,
  onFilterChange,
  counts,
  className = "",
}) => {
  const tabs = [
    {
      key: "not_signed_up" as components["schemas"]["EventAttendeeStatus"],
      label: "Not signed up",
      count: counts.not_signed_up,
    },
    {
      key: "started" as components["schemas"]["EventAttendeeStatus"],
      label: "Started",
      count: counts.started,
    },
    {
      key: "completed" as components["schemas"]["EventAttendeeStatus"],
      label: "Completed",
      count: counts.completed,
    },
    {
      key: "not_started" as components["schemas"]["EventAttendeeStatus"],
      label: "Not started",
      count: counts.not_started,
    },
    {
      key: "pending_review" as components["schemas"]["EventAttendeeStatus"],
      label: "Pending review",
      count: counts.pending_review,
    },
  ];

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {tabs.map((tab) => {
        const isActive = activeFilter === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => {
              onFilterChange(tab.key);
            }}
            className={`
              px-4 py-2 rounded-full text-sm font-medium transition-colors
              ${
                isActive
                  ? "bg-white text-black"
                  : "bg-white/10 text-white/80 hover:bg-white/20"
              }
            `}
          >
            {tab.label} ({tab.count})
          </button>
        );
      })}
    </div>
  );
};

GuestFilterTabs.defaultProps = {
  className: "",
};

export default GuestFilterTabs;
